import axios from "axios";
import { convertSortDir } from "../utils";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export const getRoutes = async (q, filter_params, page, page_size, sort_by, sort_dir) => {

    let params = filter_params
    params['page'] = page
    params['page_size'] = page_size
    params['q'] = q
    params['sort_by'] = sort_by
    params['sort_dir'] = convertSortDir(sort_dir)

    const res = await axios.get(BACKEND_URL+'/routes', {
        params,
        withCredentials: true
    });
    return res;
}

export const getRoute = async (id) => {
    const res = await axios.get(BACKEND_URL+`/routes/${id}`, {
        withCredentials: true
    });
    return res;
}

export const createRoute = async (createObj) => {
    createObj  = Object.fromEntries(Object.entries(createObj).filter(([_, v]) => v !== undefined));
    const res = await axios.post(BACKEND_URL+'/routes',
    createObj,
    {
        withCredentials: true,
        successMessage: "สายได้ถูกสร้างแล้ว"
    });
    return res;
}

export const updateRoute = async (id, updateObj) => {
    const res = await axios.put(BACKEND_URL+`/routes/${id}`,
    updateObj,
    {
        withCredentials: true,
        successMessage: "สายได้ถูกแก้ไขแล้ว"
    });
    return res;
}

export const deleteRoute = async (id) => {
    const res = await axios.delete(BACKEND_URL+`/routes/${id}`,
    {
        withCredentials: true,
        successMessage: "สายได้ถูกลบแล้ว"
    });
    return res;
}

export const restoreRoute = async (id) => {
    const res = await axios.post(BACKEND_URL+`/routes/${id}/restore`,
    {},
    {
        withCredentials: true,
        successMessage: "สายได้ถูกกู้คืนแล้ว"
    });
    return res;
}

export const getRouteCustomer = async (id, q, filter_params, page, page_size, sort_by, sort_dir) => {
    let params = filter_params
    params['page'] = page
    params['page_size'] = page_size
    params['q'] = q
    params['sort_by'] = sort_by
    params['sort_dir'] = convertSortDir(sort_dir)
    const res = await axios.get(BACKEND_URL+`/routes/${id}/customers`,
    {
        params,
        withCredentials: true
    });
    return res;
}

export const getRouteByBranch = async (branch_ids) => {
    const res = await axios.post(BACKEND_URL+`/routes/get_by_branches`,
    {
        branch_ids
    },
    {
        withCredentials: true,
        showSuccessMessage: false
    });
    return res;
}

export const sortCustomer = async (id, customerIds) => {
    const res = await axios.post(BACKEND_URL+`/routes/${id}/sort_customer`,
    {customer_ids: customerIds},
    {
        withCredentials: true,
        successMessage: "เรียงลำดับลูกค้าสำเร็จ"
    });
    return res;
}